<tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>

<tt-card *ngIf="page?.show_setting === '1'">
    <tt-button-settings ttWebpageName="acvouchertypes" (ttClick)="openSettings($event)"></tt-button-settings>
</tt-card>
